module.exports = __webpack_public_path__ + "0-es2015.ada689ee512a7b44e439.worker.js"